import { jsx as _jsx } from "react/jsx-runtime";
import { COLOR_PALETTE } from '../constants';
/**
 * Компонент выбора цвета из палитры
 * Отображает сетку цветов для выбора
 */
const ColorPicker = ({ currentColor, onColorChange, onClose, }) => {
    const handleColorSelect = (color) => {
        onColorChange(color);
        onClose();
    };
    return (_jsx("div", { className: "dropdown-menu color-menu", children: _jsx("div", { className: "color-grid", children: COLOR_PALETTE.map((color) => (_jsx("button", { type: "button", className: "color-button", style: { backgroundColor: color }, onClick: () => handleColorSelect(color), title: color, "aria-label": `Выбрать цвет ${color}` }, color))) }) }));
};
export default ColorPicker;
